import React, { useState } from 'react';
import { SmileBag } from '../../../images/mis-otras-lineas';
import {
  InfoCreditBannerWrapper,
  InfoCreditBottom,
  InfoCreditTop,
  ShowMore,
} from './styles/InfoCreditBannerStyles';
import useUser from '../../../hooks/useUser';
import { Numbers } from '../../../helpers';
import useOtherLines from '../../../hooks/useOtherLines';

const InfoCreditBanner = () => {
  const [show, setShow] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const {
    beneficiaryNumber,
    actionType,
    credit,
    errorCredit,
  } = useOtherLines();
  const { creditAvailable } = credit;
  const [mount, setMount] = useState(creditAvailable);

  const {
    user: { isAdmin },
  } = useUser();

  const handleShow = () => setShow(!show);

  useState(() => {
    setPhoneNumber(beneficiaryNumber);
  }, [beneficiaryNumber]);

  useState(() => {
    if (creditAvailable) {
      setMount(Numbers.addThousandSeparators(Number(creditAvailable)));
    }
  }, [creditAvailable]);

  return (
    <InfoCreditBannerWrapper>
      <InfoCreditTop>
        <SmileBag />
        <p>
          Estás haciendo una
          {actionType === 'recarga' ? ' recarga ' : ' compra '}para:
          <strong> +{phoneNumber}</strong>
        </p>
      </InfoCreditTop>
      {isAdmin && !errorCredit && (
        <InfoCreditBottom showInfo={show}>
          <p>
            Te quedan
            <strong> ${mount} </strong>
            para comprar con cargo a tu boleta.
          </p>
          {show && (
            <>
              <p>
                El límite de crédito mensual para realizar compras adicionales
                con cargo a tu boleta es de $10.000.
              </p>
              <p>
                Si llegas al límite solo podrás pagar con Webpay u otros medios
                de pago.
              </p>
            </>
          )}
          <ShowMore showInfo={show} onClick={handleShow}>
            {show ? 'Ocultar Información' : ' Ver más información'}
          </ShowMore>
        </InfoCreditBottom>
      )}
    </InfoCreditBannerWrapper>
  );
};

export default InfoCreditBanner;
